module.exports = __webpack_public_path__ + "static/media/Fuel Injection Nozzle.a1bf06ad.webp";